/* Přidej do patičky:
<script type="text/javascript">
    var formServicesDirectory = THEME_URI + '/services/';
    var formErrorMessage = "<?php _e("Před odesláním prosím doplňte/opravte data ve formuláři.", THEME_TEXT_DOMAIN); ?>\n";
    var gdprError = "<?php _e("Před odesláním musíte souhlasit se zpracováním osobních údajů.", THEME_TEXT_DOMAIN); ?>";
	var ajaxUrl = "<?php echo admin_url('admin-ajax.php'); ?>";
</script>
 */

initForms();

/**
 * Inicializuje všechny formuláře na stránce.
 * Zde se registrují submit handlery pro jednotlivé formuláře projektu.
 *
 * Jak přidat nový formulář:
 * 1. Zkopíruj komentovaný template níže
 * 2. Nahraď CSS-CLASS-FORM CSS třídou formulářového elementu <form>
 * 3. Nahraď AJAX_ACTION názvem akce z PHP handleru (wp_ajax_{AJAX_ACTION})
 *
 * Globální proměnné (musí být definovány v patičce šablony):
 * - ajaxUrl          URL na admin-ajax.php
 * - formErrorMessage Chybová hláška při neplatných polích
 * - gdprError        Chybová hláška při nezaškrtnutém GDPR
 *
 * @returns {void}
 */
function initForms() {

    var afterSendFunction = function () {
        // Callback volaný po úspěšném odeslání – přizpůsob dle potřeby
    };

    /* Template – zkopíruj a uprav:
	$(".CSS-CLASS-FORM").submit(function (e) {
		e.preventDefault();
		sendForm($(this), "AJAX_ACTION", afterSendFunction);
		return false;
	});*/
}

/**
 * Odešle formulář přes AJAX na WordPress admin-ajax.php.
 *
 * Před odesláním provede validaci:
 * - Formát emailu (pole s data-format="email")
 * - Formát telefonu (pole s data-format="phone")
 * - GDPR checkbox (pole s data-gdpr="1") – pokud není zaškrtnutý, odeslání se zastaví
 *
 * Odpovědi ze serveru:
 * - ["ok"]              → Formulář přidá třídu 'send' na .error-message, vyčistí pole
 * - ["fields", [...]]  → Polím s chybou přidá třídu 'with-empty-error' na .form-group
 * - ["error"]          → Formulář přidá třídu 'error' na .error-message
 *
 * Během odesílání má formulář třídu 'sending' (pro zobrazení loaderu).
 *
 * @param {jQuery} $form          - jQuery objekt formuláře
 * @param {string} action         - Název AJAX akce (registrované v PHP přes wp_ajax_{action})
 * @param {Function} afterSendMethod - Callback volaný po zpracování odpovědi ze serveru
 * @returns {void}
 */
function sendForm($form, action, afterSendMethod) {

    var hasError = false;

    $form.find(".form-group").removeClass("with-empty-error").removeClass("with-format-error");
	$form.find(".error-message").removeClass("show").removeClass("error").removeClass("send");

    // email
    $form.find("input[data-format='email']").each(function () {
        if ($(this).val().length > 0) {
            if (!validateEmail($(this).val())) {
                hasError = true;
                $(this).closest(".form-group").addClass("with-format-error");
            }
        }
    });

    // phone
    $form.find("input[data-format='phone']").each(function (){
        if ($(this).val().length > 0) {
            if (!validatePhone($(this).val())) {
                hasError = true;
                $(this).closest(".form-group").addClass("with-format-error");
            }
        }
    });

    // GDPR
    if (!$form.find("input[data-gdpr]").is(":checked")) {
        alert(gdprError);
        return false;
    }

    if (hasError) {
        alert(formErrorMessage);
    }else {
        // send form by AJAX
        $form.addClass("sending");
		$.ajax({
			type: "POST",
			url: ajaxUrl,
			data: {
				action: action, 
				form_data: $form.serialize(),
			},
			success: function(response) {
				console.log(response);
				if(response[0] == "fields") {
					$.each(response[1], function (indexInArray, valueOfElement) { 
						$("input[name='"+valueOfElement+"'").closest(".form-group").addClass("with-empty-error");
					});
				}else if(response[0] == "error") {
					$form.find(".error-message p").text(formSendingErrorMessage);
					$form.find(".error-message").addClass("show").addClass("error");
				}else {
					$form.find(".error-message p").text(formSendingOkrMessage);
					$form.find(".error-message").addClass("show").addClass("send");
					$form.find("input").val("");
					$form.find("textarea").val("");
					$form.find("input[type='checkbox']").iCheck("toggle");
				}
				$form.removeClass("sending");

				afterSendMethod();
			},
			error: function(xhr, ajaxOptions, thrownError) {
				var err = eval("(" + xhr.responseText + ")");
				console.log(err.Message);
				console.log(xhr.status);
				console.log(thrownError);
			}
		});
    }
}

/**
 * Odešle formulář s přílohami přes AJAX (FormData — podporuje input[type="file"]).
 * Rozhraní totožné se sendForm(), liší se způsobem přenosu dat.
 *
 * @param {jQuery} $form
 * @param {string} action
 * @param {Function} afterSendMethod
 * @returns {void}
 */
function sendFormWithFiles($form, action, afterSendMethod) {

    var hasError = false;

    $form.find(".form-group").removeClass("with-empty-error").removeClass("with-format-error");
    $form.find(".error-message").removeClass("show").removeClass("error").removeClass("send");

    // email
    $form.find("input[data-format='email']").each(function () {
        if ($(this).val().length > 0) {
            if (!validateEmail($(this).val())) {
                hasError = true;
                $(this).closest(".form-group").addClass("with-format-error");
            }
        }
    });

    // phone
    $form.find("input[data-format='phone']").each(function () {
        if ($(this).val().length > 0) {
            if (!validatePhone($(this).val())) {
                hasError = true;
                $(this).closest(".form-group").addClass("with-format-error");
            }
        }
    });

    // GDPR
    if (!$form.find("input[data-gdpr]").is(":checked")) {
        alert(gdprError);
        return false;
    }

    if (hasError) {
        alert(formErrorMessage);
    } else {
        $form.addClass("sending");

        var formData = new FormData();
        formData.append("action", action);
        formData.append("form_data", $form.serialize());

        $form.find("input[type='file']").each(function () {
            if (this.files.length > 0) {
                formData.append($(this).attr("name"), this.files[0]);
            }
        });

        $.ajax({
            type: "POST",
            url: ajaxUrl,
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {
                if (response[0] === "fields") {
                    $.each(response[1], function (i, fieldName) {
                        $("input[name='" + fieldName + "'], textarea[name='" + fieldName + "']")
                            .closest(".form-group").addClass("with-empty-error");
                    });
                } else if (response[0] === "error") {
                    $form.find(".error-message p").text(formSendingErrorMessage);
                    $form.find(".error-message").addClass("show").addClass("error");
                } else {
                    $form.find(".error-message p").text(formSendingOkrMessage);
                    $form.find(".error-message").addClass("show").addClass("send");
                    $form.find("input:not([type='hidden']):not([type='checkbox'])").val("");
                    $form.find("textarea").val("");
                    $form.find("input[type='checkbox']").prop("checked", false);
                }
                $form.removeClass("sending");
                afterSendMethod();
            },
            error: function () {
                $form.find(".error-message p").text(formSendingErrorMessage);
                $form.find(".error-message").addClass("show").addClass("error");
                $form.removeClass("sending");
            },
        });
    }
}

/**
 * Ověří, zda zadaný řetězec odpovídá formátu emailové adresy.
 *
 * @param {string} email - Řetězec k ověření
 * @returns {boolean} true pokud je email platný, false pokud není
 */
function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

/**
 * Ověří, zda zadaný řetězec odpovídá formátu telefonního čísla.
 * Podporuje mezinárodní předvolbu (+420, +49, ...) a skupiny číslic oddělené mezerami.
 * Vzor: [+XXX] [XXX] [XXX] [XXX]
 *
 * @param {string} phone - Řetězec k ověření
 * @returns {boolean} true pokud je telefon platný, false pokud není
 */
function validatePhone(phone) {
    //var re = /^(\+420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/;
    var re = /^(\+[0-9]{1,3})?( )?[0-9]{3}( )?[0-9]{3}( )?[0-9]{3}$/;
    return re.test(phone);
}